import request from "@/utils/request"

const loadAccounts = () => {
  return request.get("/api/settings/accounts")
}

const unlinkSocialAccount = (type) =>
  request.delete("/api/social_accounts", {
    params: { type },
    token: true
  })

const addLogin = (email, password) =>
  request.post("/api/blinkist_account", {
    body: { email, password },
    token: true
  })

const changePassword = (oldPassword, newPassword) =>
  request.put("/api/password", {
    body: {
      old_password: oldPassword /* eslint-disable-line camelcase */,
      password1: newPassword,
      password2: newPassword
    },
    token: true
  })

// Used for creating a new password when a user has temporary password stored in their session
// Old password will be set from session
const createPassword = (newPassword) => changePassword(undefined, newPassword)

const changeEmail = (email, password) =>
  request.put("/api/blinkist_account", {
    body: {
      email,
      password
    },
    token: true
  })

const cancelSubscription = (cancellationReason, sku) =>
  request.delete("/api/subscription", {
    body: {
      reason: cancellationReason,
      sku: sku
    },
    token: true
  })

const deleteAccount = (password) =>
  request.delete("/api/blinkist_account", {
    body: { password },
    token: true
  })

const loadEmailPreferences = () => {
  return request.get("/api/settings/email_optins")
}

const addToList = (email) =>
  request.patch(`/api/settings/email_optins/${email}`, {
    token: true
  })

const removeFromList = (email) =>
  request.delete(`/api/settings/email_optins/${email}`, {
    token: true
  })

const updateEmailSubscriptionStatus = (status) =>
  request.patch(`/api/settings/email_subscription_status/${status}`, {
    token: true
  })

export default {
  loadAccounts,
  unlinkSocialAccount,
  addLogin,
  changePassword,
  createPassword,
  changeEmail,
  cancelSubscription,
  deleteAccount,
  loadEmailPreferences,
  addToList,
  removeFromList,
  updateEmailSubscriptionStatus
}
